import {
    Col,
    Row,
    Input,
    Button,
} from 'antd';
import { IoReloadOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import { SearchParamValue } from '../../interfaces/paginate.interface';

interface Props {
    loading: boolean;
    handleSearchParam: (key: string, value: SearchParamValue) => void;
    refreshData: () => void;
}

const { Search }: any = Input;

const Filters = ({
    loading,
    handleSearchParam,
    refreshData,
}: Props) => {
    const { t } = useTranslation('drivers', { keyPrefix: 'DRIVERS' });

    return (
        <Row className="home__filters" gutter={[16, 16]} justify="start" align="top">
            <Col className="home__filters--col-search">
                <Search
                    style={{ width: 300 }}
                    allowClear
                    placeholder={t('SEARCH')}
                    onSearch={(value: string) => handleSearchParam('search', value)}
                    enterButton
                    disabled={loading}
                />
            </Col>
            <Col>
                <Button
                    type="ghost"
                    icon={<IoReloadOutline style={{ verticalAlign: 'middle' }} />}
                    onClick={() => refreshData()}
                />
            </Col>
        </Row>
    );
};

export { Filters };
